/**
 * Превью файла, ещё не загруженного на сервер, и просмотр в полный размер.
 *
 * До создания задачи вложения живут только в браузере: ссылки «на
 * просмотр» у них нет, поэтому картинка показывается из самого файла
 * через object URL. Ссылку создаёт и освобождает владелец списка файлов —
 * в момент добавления и удаления файла, а не эффектом превью: StrictMode
 * повторно запускает эффекты и отзывал бы ссылку, которая ещё на экране.
 */

import { Paperclip, Play } from "lucide-react";
import { useState } from "react";

import { Modal } from "@/shared/ui";

export function LocalFilePreview({
  name,
  url,
  video = false,
}: {
  name: string;
  url: string | null;
  /** Запись экрана: просмотр — проигрывателем, а не картинкой. */
  video?: boolean;
}) {
  const [broken, setBroken] = useState(false);
  const [viewing, setViewing] = useState(false);

  if (url === null || broken) {
    return <Paperclip className="size-3.5 shrink-0 text-faint" aria-hidden />;
  }

  return (
    <>
      <button
        type="button"
        className="size-10 shrink-0 overflow-hidden rounded border border-line bg-sunken focus-visible:outline-2 focus-visible:outline-accent"
        aria-label={`Открыть ${name}`}
        title={video ? "Просмотреть запись" : "Открыть в полном размере"}
        onClick={() => setViewing(true)}
      >
        {video ? (
          <Play className="mx-auto size-4 text-muted" aria-hidden />
        ) : (
          <img src={url} alt="" className="size-full object-cover" onError={() => setBroken(true)} />
        )}
      </button>

      <Modal open={viewing} onClose={() => setViewing(false)} title={name} width="xl">
        {video ? (
          <video
            src={url}
            controls
            autoPlay
            className="mx-auto block max-h-[calc(100dvh-12rem)] max-w-full bg-black"
            onError={() => setBroken(true)}
          />
        ) : (
          <img
            src={url}
            alt={name}
            className="mx-auto block max-h-[calc(100dvh-12rem)] max-w-full object-contain"
          />
        )}
      </Modal>
    </>
  );
}
